import IMPComponent from '../../../components/interfaces/IMPComponent';
import * as React from 'react';
import { isProFeaturesAvailable, Page, PagesMap, SubscriptionState } from '../../../Models';
import { dailyPeriod } from '../../Stats/Models';
import moment from 'moment';
import WritingStats, { WritingStatProps } from '../../Stats/Components/WritingStats';
import styled from 'styled-components';
import { EmotionsAndTopicsStats } from '../../Stats/Components/EmotionsAndTopicsStats';
import { StatsBlock } from '../../Stats/Components/Common';
import Button from '../../../components/Button';
import PATHS from '../../../constants/paths';
import { Link } from 'react-router-dom';
import { TrialInfoComponent } from '../../../components/TrialInfo';
import { buildInsightsReport, writingTimeStringReport } from '../../Stats/Logic/Reports';
import { useIntl } from 'react-intl';
import { moodTypeFromValue } from '../../Stats/Logic/MoodStatsLogic';

interface PageStatsProps extends IMPComponent {
  readonly page: Page;
  subscriptionState: SubscriptionState | null;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  height: 100%;
`;

const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;

  div:first-child {
    margin-right: 20px;
    flex-grow: 2;
  }

  div:last-child {
    margin-right: 0;
    flex-grow: 1;
  }
`;

const PageWritingStats = styled(WritingStats)`
  padding: 20px 20px;
`;

const PageEmotionsContainer = styled(EmotionsAndTopicsStats)`
  margin-top: 20px;
  height: 250px;
  flex-grow: 0;
`;

const UpgradeContainer = styled(StatsBlock)`
  flex-direction: row;
  padding: 20px;
  margin-top: 20px;
`;

const UpgradeTitle = styled.span`
  color: ${p => p.theme.color.battleshipGrey};
  font-size: ${p => p.theme.font.size.small};
  line-height: 1.5;
  padding-right: 20px;
`;

const UpgradeComponent = () => {
  return (
    <UpgradeContainer>
      <UpgradeTitle>Upgrade to unlock Mood, Emotions & Topics insights</UpgradeTitle>
      <Link to={PATHS.STATISTICS.INDEX}>
        <Button>Upgrade</Button>
      </Link>
    </UpgradeContainer>
  );
};

export const PageInsights = (props: PageStatsProps) => {
  const intl = useIntl();
  const messageBase = 'containers.PagesHistory.PageInsights';

  const pagesMap: PagesMap = { [props.page.dateId]: props.page };

  const date = moment(props.page.createdAt).toDate();
  const report = buildInsightsReport(dailyPeriod(date), pagesMap);

  const stats: WritingStatProps[] = [
    {
      title: intl.formatMessage({
        id: `${messageBase}.words`,
      }),
      stat: report.wordsReport.total ? `${report.wordsReport.total}` : `0`,
      change: -1, // skip showing change
    },
    {
      title: intl.formatMessage({
        id: `${messageBase}.writing_time`,
      }),
      stat: writingTimeStringReport(report.timeReport.total),
      change: -1, // skip showing change
    },
  ];

  const moodValue = props.page.analysis && props.page.analysis.sentiment.analysis;

  const mood: WritingStatProps[] = [
    {
      title: intl.formatMessage({
        id: `${messageBase}.mood`,
      }),
      stat: moodValue ? moodTypeFromValue(moodValue) : '-',
      change: 0,
    },
  ];

  const showUpgrade = !isProFeaturesAvailable(props.subscriptionState);

  const showTrialPagesLeft = props.subscriptionState && !props.subscriptionState.isSubscribed;

  return (
    <Container>
      <HorizontalContainer>
        <PageWritingStats stats={stats} />
        {!showUpgrade && <PageWritingStats stats={mood} />}
      </HorizontalContainer>
      {showUpgrade ? (
        <UpgradeComponent />
      ) : (
        <PageEmotionsContainer
          emotions={report.emotionsReport.emotions}
          topics={report.emotionsReport.topics}
          failedStatuses={report.emotionsReport.failedStatuses}
        />
      )}
      {showTrialPagesLeft && <TrialInfoComponent trialAnalysisLeft={props.subscriptionState!.trialAnalysisLeft} />}
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PageInsights/index.tsx